import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import UserTypes from "components/auth/user-types";
import Spinner from "components/common/Spinner";
import {
    closeCustomModal,
    openCustomModal
} from "components/custom/modals";
import {
    fetchCustomerInvoicingInvoices,
    fetchMerchandiserPdfInvoice,
    approveMerchandiserInvoices
} from "api/menu/invoicing/actions";

import ListInvoicesHeader from "components/menu/invoicing/customer/list-invoices-header";
import ListInvoicesInvoices from "components/menu/invoicing/customer/list-invoices-invoices";

class ListInvoices extends React.Component {
    dateFormat = "YYYY-MM-DD";

    defaultFilters = {
        fromDate: moment().startOf("month"),
        toDate: moment().endOf("month"),
        jobId: null,
        supplerId: null,
    };

    constructor(props) {
        super(props);

        this.state = {
            filters: this.defaultFilters,
        };

        this.getRequestData = this.getRequestData.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleLoad = this.handleLoad.bind(this);
        this.handleReset = this.handleReset.bind(this);

        this.handleLoad();
    }

    getRequestData = () => {
        const {
            fromDate,
            toDate,
            jobId,
            supplierId,
        } = this.state.filters;

        const requestData = {};
        if (fromDate) {
            requestData.fromDate = moment(fromDate).format(this.dateFormat);
        }
        if (toDate) {
            requestData.toDate = moment(toDate).format(this.dateFormat);
        }
        if (jobId) {
            requestData.jobId = jobId.value;
        }
        if (supplierId) {
            requestData.supplierId = supplierId.value;
        }

        return requestData;
    };

    handleSelect = (inputsArr) => {
        const filters = Object.assign({}, this.state.filters);
        inputsArr.forEach(item => {
            filters[item.name] = item.value;
        });
        this.setState({
            filters
        });
    };

    handleLoad = ()  => {
        this.props.fetchCustomerInvoicingInvoices(this.getRequestData());
    };

    handleReset = () => {
        this.setState({
            filters: this.defaultFilters
        }, () => this.props.fetchCustomerInvoicingInvoices(this.getRequestData()));
    };

    render() {
        const {
            loading,
            userRole,
            customerInvoices
        } = this.props;

        const isAdminView = userRole.includes(UserTypes.admin);

        return (
            <div className="position-relative">
                {!loading || <Spinner />}

                <ListInvoicesHeader
                    handleLoad={this.handleLoad}
                    handleReset={this.handleReset}
                    handleSelect={this.handleSelect}
                    filters={this.state.filters}
                />

                <div className="mb-4">
                    <ListInvoicesInvoices
                        data={customerInvoices || []}
                        handleLoad={this.handleLoad}
                        isAdminView={isAdminView}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userRole: state.auth.user.role,
    loading: state.invoicing.loading,
    customerInvoices: state.invoicing.customerInvoices
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    fetchCustomerInvoicingInvoices:
        bindActionCreators(fetchCustomerInvoicingInvoices, dispatch),
    fetchMerchandiserPdfInvoice: bindActionCreators(fetchMerchandiserPdfInvoice, dispatch),
    approveMerchandiserInvoices: bindActionCreators(approveMerchandiserInvoices, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ListInvoices);
